import React from 'react';

interface AIAssistantIconProps {
  size?: number;
  color?: string;
  className?: string;
  animate?: boolean;
}

const AIAssistantIcon: React.FC<AIAssistantIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '',
  animate = false
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`ai-assistant-icon ${animate ? 'animate' : ''} ${className}`}
    >
      {/* Neural network nodes */}
      <circle cx="6" cy="6" r="1.5" fill={color} opacity="0.8">
        {animate && (
          <animate
            attributeName="opacity"
            values="0.8;1;0.8"
            dur="2s"
            repeatCount="indefinite"
          />
        )}
      </circle>
      <circle cx="12" cy="4" r="1.5" fill={color} opacity="0.9">
        {animate && (
          <animate
            attributeName="opacity"
            values="0.9;1;0.9"
            dur="2.2s"
            repeatCount="indefinite"
          />
        )}
      </circle>
      <circle cx="18" cy="6" r="1.5" fill={color} opacity="0.7">
        {animate && (
          <animate
            attributeName="opacity"
            values="0.7;1;0.7"
            dur="1.8s"
            repeatCount="indefinite"
          />
        )}
      </circle>
      <circle cx="4" cy="12" r="1.5" fill={color} opacity="0.8">
        {animate && (
          <animate
            attributeName="opacity"
            values="0.8;1;0.8"
            dur="2.1s"
            repeatCount="indefinite"
          />
        )}
      </circle>
      <circle cx="12" cy="12" r="2" fill={color}>
        {animate && (
          <animate
            attributeName="r"
            values="2;2.3;2"
            dur="1.5s"
            repeatCount="indefinite"
          />
        )}
      </circle>
      <circle cx="20" cy="12" r="1.5" fill={color} opacity="0.8">
        {animate && (
          <animate
            attributeName="opacity"
            values="0.8;1;0.8"
            dur="1.9s"
            repeatCount="indefinite"
          />
        )}
      </circle>
      <circle cx="6" cy="18" r="1.5" fill={color} opacity="0.7">
        {animate && (
          <animate
            attributeName="opacity"
            values="0.7;1;0.7"
            dur="2.3s"
            repeatCount="indefinite"
          />
        )}
      </circle>
      <circle cx="12" cy="20" r="1.5" fill={color} opacity="0.9">
        {animate && (
          <animate
            attributeName="opacity"
            values="0.9;1;0.9"
            dur="1.7s"
            repeatCount="indefinite"
          />
        )}
      </circle>
      <circle cx="18" cy="18" r="1.5" fill={color} opacity="0.8">
        {animate && (
          <animate
            attributeName="opacity"
            values="0.8;1;0.8"
            dur="2.4s"
            repeatCount="indefinite"
          />
        )}
      </circle>

      {/* Neural network connections */}
      <g stroke={color} strokeWidth="0.8" opacity="0.4">
        <line x1="6" y1="6" x2="12" y2="4">
          {animate && (
            <animate
              attributeName="opacity"
              values="0.4;0.8;0.4"
              dur="3s"
              repeatCount="indefinite"
            />
          )}
        </line>
        <line x1="12" y1="4" x2="18" y2="6">
          {animate && (
            <animate
              attributeName="opacity"
              values="0.4;0.8;0.4"
              dur="2.8s"
              repeatCount="indefinite"
            />
          )}
        </line>
        <line x1="6" y1="6" x2="4" y2="12">
          {animate && (
            <animate
              attributeName="opacity"
              values="0.4;0.8;0.4"
              dur="3.2s"
              repeatCount="indefinite"
            />
          )}
        </line>
        <line x1="18" y1="6" x2="20" y2="12">
          {animate && (
            <animate
              attributeName="opacity"
              values="0.4;0.8;0.4"
              dur="2.6s"
              repeatCount="indefinite"
            />
          )}
        </line>
        <line x1="6" y1="6" x2="12" y2="12">
          {animate && (
            <animate
              attributeName="opacity"
              values="0.4;0.8;0.4"
              dur="2.9s"
              repeatCount="indefinite"
            />
          )}
        </line>
        <line x1="12" y1="4" x2="12" y2="12">
          {animate && (
            <animate
              attributeName="opacity"
              values="0.4;0.8;0.4"
              dur="3.1s"
              repeatCount="indefinite"
            />
          )}
        </line>
        <line x1="18" y1="6" x2="12" y2="12">
          {animate && (
            <animate
              attributeName="opacity"
              values="0.4;0.8;0.4"
              dur="2.7s"
              repeatCount="indefinite"
            />
          )}
        </line>
        <line x1="4" y1="12" x2="12" y2="12">
          {animate && (
            <animate
              attributeName="opacity"
              values="0.4;0.8;0.4"
              dur="3.3s"
              repeatCount="indefinite"
            />
          )}
        </line>
        <line x1="12" y1="12" x2="20" y2="12">
          {animate && (
            <animate
              attributeName="opacity"
              values="0.4;0.8;0.4"
              dur="2.5s"
              repeatCount="indefinite"
            />
          )}
        </line>
        <line x1="6" y1="18" x2="12" y2="12">
          {animate && (
            <animate
              attributeName="opacity"
              values="0.4;0.8;0.4"
              dur="3.4s"
              repeatCount="indefinite"
            />
          )}
        </line>
        <line x1="12" y1="12" x2="12" y2="20">
          {animate && (
            <animate
              attributeName="opacity"
              values="0.4;0.8;0.4"
              dur="2.4s"
              repeatCount="indefinite"
            />
          )}
        </line>
        <line x1="18" y1="18" x2="12" y2="12">
          {animate && (
            <animate
              attributeName="opacity"
              values="0.4;0.8;0.4"
              dur="3.5s"
              repeatCount="indefinite"
            />
          )}
        </line>
        <line x1="6" y1="18" x2="12" y2="20">
          {animate && (
            <animate
              attributeName="opacity"
              values="0.4;0.8;0.4"
              dur="2.3s"
              repeatCount="indefinite"
            />
          )}
        </line>
        <line x1="12" y1="20" x2="18" y2="18">
          {animate && (
            <animate
              attributeName="opacity"
              values="0.4;0.8;0.4"
              dur="3.6s"
              repeatCount="indefinite"
            />
          )}
        </line>
      </g>

      {/* Central brain/processing indicator */}
      <circle cx="12" cy="12" r="3" fill="none" stroke={color} strokeWidth="0.5" opacity="0.3">
        {animate && (
          <animate
            attributeName="r"
            values="3;3.5;3"
            dur="4s"
            repeatCount="indefinite"
          />
        )}
      </circle>
    </svg>
  );
};

export default AIAssistantIcon;

